<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目通知管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        :v-model="query"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索" prop="name">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>通知记录列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="content" label="通知内容"></el-table-column>
          <el-table-column prop="mobile" label="通知电话"></el-table-column>
          <el-table-column prop="email" label="通知邮箱"></el-table-column>
          <el-table-column prop="remark" label="说明"></el-table-column>
          <el-table-column prop="createTime" label="通知时间"></el-table-column>

          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="查看通知" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="recordeClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column> -->
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <!-- <el-dialog :title="form.id>0?'编辑项目通知信息':'添加项目通知信息'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item label="说明" prop="summary">
          <el-input v-model="form.summary" placeholder="请输入通知说明"></el-input>
        </el-form-item>

        <el-form-item
          label="通知内容"
          prop="content"
          :rules="[
        {required:true,message:'请输入通知内容'}
        ]"
        >
          <el-input type="textarea" v-model="form.content" placeholder="请输入通知内容"></el-input>
        </el-form-item>

        <el-form-item label="通知人" prop="linkName" :rules="[{required:true,message:'请输入通知人'}]">
          <el-input v-model="form.linkName" placeholder="请输入通知人"></el-input>
        </el-form-item>

        <el-form-item label="通知电话" prop="mobile" :rules="[{required:true,message:'请输入通知电话'}]">
          <el-input v-model="form.mobile" placeholder="请输入通知电话"></el-input>
        </el-form-item>

        <el-form-item label="通知邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入通知邮箱"></el-input>
        </el-form-item>

        <el-form-item label="到期时间" prop="endDate" :rules="[{required:true,message:'请选择到期时间'}]">
          <el-date-picker
            v-model="form.endDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择到期时间"
          ></el-date-picker>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="state" :rules="[{required:true,message:'请选择合作状态'}]">
              <el-select v-model="form.state" filterable>
                <el-option
                  v-for="item in stateList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->

    <!-- 查看通知对话框 -->
    <!-- <el-dialog :title="form.id>0?'项目通知信息':'添加项目通知信息'" :visible.sync="dialogRecordVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
      >

        <el-form-item label="项目名称" prop="projectName" :rules="[{required:true,message:'请输入项目名称'}]">
          <el-input v-model="form.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>

        <el-form-item label="说明" prop="summary">
          <el-input v-model="form.summary" placeholder="请输入通知说明"></el-input>
        </el-form-item>

        <el-form-item
          label="通知内容"
          prop="content"
          :rules="[
        {required:true,message:'请输入通知内容'}
        ]"
        >
          <el-input type="textarea" v-model="form.content" placeholder="请输入通知内容"></el-input>
        </el-form-item>

        <el-form-item label="通知人" prop="linkName" :rules="[{required:true,message:'请输入通知人'}]">
          <el-input v-model="form.linkName" placeholder="请输入通知人"></el-input>
        </el-form-item>

        <el-form-item label="通知电话" prop="mobile" :rules="[{required:true,message:'请输入通知电话'}]">
          <el-input v-model="form.mobile" placeholder="请输入通知电话"></el-input>
        </el-form-item>

        <el-form-item label="通知邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入通知邮箱"></el-input>
        </el-form-item>

        <el-form-item label="到期时间" prop="endDate" :rules="[{required:true,message:'请选择到期时间'}]">
          <el-date-picker
            v-model="form.endDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择到期时间"
          ></el-date-picker>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="state" :rules="[{required:true,message:'请选择合作状态'}]">
              <el-select v-model="form.state" filterable>
                <el-option
                  v-for="item in stateList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogRecordVisible=false">取消</el-button>
        </el-form-item>

      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="dialogRecordVisible=false">关闭</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      noticeid: "",
      key: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      recordlist:[],
      dialogVisible: false,
      submiting: false,
      dialogRecordVisible: false,
      id: 0,
      stateList: [
        {
          id: 1,
          name: "未处理"
        },
        {
          id: 2,
          name: "已处理"
        }
      ],
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    //获取项目列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.noticeid = _this.noticeid;
      params.key = _this.key;
      var link = url.getProject("getlist_record");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getProject("addorupdate_notice");
      var info = this.form;
      info.projectid = this.projectid;
      // console.info(info)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function(row) {
      var _this = this;
      var link = url.getProject("delete_notice"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 查看通知记录
    recordeClick:function(row){
    },
  },
  mounted() {
    // this.recordeClick();
    var _this = this;
    //接收参数id
    _this.noticeid = this.$route.query.id;
    if (_this.noticeid > 0) {
      _this.getList();
    } else {
      _this.form = {};
    }
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>

